import {
  AnalysesTypes,
  AnalysesTypesLowercase,
} from 'src/app/analyses/interfaces/analyses.types';
import { SemanticType } from 'src/app/shared/constants/semantic-type';

export const Colors = {
  [SemanticType.MOST_FAVOURABLE]: {
    primary: '#33C7C9',
    secondary: '#D9F5F5',
  },
  [SemanticType.FAVOURABLE]: {
    primary: '#45E4E2',
    secondary: '#E2FBFB',
  },
  [SemanticType.NEUTRAL]: {
    primary: '#889AF8',
    secondary: '#EFEFF4',
  },
  [SemanticType.AVERAGE]: {
    primary: '#FFD735',
    secondary: '#FFF9DF',
  },
  [SemanticType.LESS_FAVOURABLE]: {
    primary: '#FFB233',
    secondary: '#FFF3DF',
  },
  [SemanticType.UNFAVOURABLE]: {
    primary: '#FF6199',
    secondary: '#FFE6EE',
  },
  [SemanticType.UNKNOWN]: {
    primary: '#9599AA',
    secondary: '#EFEFF4',
  },
  GRAY: {
    primary: '#60606C',
    secondary: '#EFEFF4',
  },
};

export class ColorUtil {
  static readonly Gray = '#C7C7D2';
  static readonly TextMuted = '#9599AA';

  static hexToRGBA(hex: string, opacity: number): string {
    // eslint-disable-next-line max-len
    return (
      'rgba(' +
      (hex = hex.replace('#', ''))
        .match(new RegExp('(.{' + hex.length / 3 + '})', 'g'))
        .map((l) => parseInt(hex.length % 2 ? l + l : l, 16))
        .concat(opacity || 0)
        .join(',') +
      ')'
    );
  }

  static getColorByAnalysisType(
    type: AnalysesTypes | AnalysesTypesLowercase
  ): string {
    switch (type) {
      case AnalysesTypes.Blood:
      case AnalysesTypesLowercase.Blood:
      case AnalysesTypes.BloodSimple:
        return 'red';
      case AnalysesTypes.Questionnaire:
      case AnalysesTypes.Habits:
      case AnalysesTypesLowercase.Habits:
        return 'green';
      default:
        return 'yellow';
    }
  }
}
